import * as React from "react";
import { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgAnglesRight = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32" width="1em" height="1em" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" d="m4 0 14.286 16L4 32l-1.714-1.714L14.857 16 2.286 1.714zm11.429 0 14.285 16L15.43 32l-1.715-1.714L26.286 16 13.714 1.714z" /></svg>;
export default SvgAnglesRight;